import { useParams } from 'react-router-dom'
import { Trans, useTranslation } from 'react-i18next'
import { Suspense, useState } from 'react'
import {
  Button,
  Col,
  ConfigProvider,
  Form,
  Row,
  Space,
  theme,
  Typography,
} from 'antd'
import { errorResponse } from '../../lib/errorResponse'
import { gutter } from '../../lib/layout'
import { LoadingAnimation } from '../LoadingAnimation'
import { FileInputFormItem } from './FileInputFormItem'
import { FilePdfOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import { helpCenterLinks } from '../../config/helpCenterLinks'
import { useOnboardingHelpLink } from '../../lib/useOnboardingHelpLink'
import { accountingSoftware } from './accountingSoftware'

export function StepUploadDLSDocuments({
  onboarding,
  sessionToken,
  goToNext,
  goToNextText,
  goToPrevious,
}) {
  const { companyUid } = useParams()
  const helpLink = useOnboardingHelpLink(companyUid)
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()

  const { token } = theme.useToken()

  async function onSubmit() {
    setLoading(true)
    try {
      goToNext()
    } catch (e) {
      errorResponse(e)
    } finally {
      setLoading(false)
    }
  }

  async function uploading(upload) {
    setLoading(upload)
  }

  const software = accountingSoftware[onboarding.software]

  const softwareName =
    onboarding.software === 'misc'
      ? onboarding.miscSoftwareName
      : software?.label

  const [form] = Form.useForm()

  return (
    <Form form={form} layout="vertical" onFinish={onSubmit}>
      <Row gutter={gutter}>
        <ConfigProvider
          theme={{
            components: {
              Button: {
                fontSize: token.fontSize,
                paddingContentHorizontal: token.paddingContentHorizontal,
                controlHeight: token.controlHeight,
                borderRadius: token.borderRadius,
              },
            },
          }}
        >
          <Col span={24}>
            <Typography.Paragraph>
              <Trans
                i18nKey="frontend:onboarding.dlsUploadDescription"
                components={{ strong: <strong /> }}
                values={{ companyName: onboarding.company.name }}
              />
            </Typography.Paragraph>
          </Col>
          {onboarding.software !== 'misc' && (
            <Col span={24}>
              <Button
                style={{ height: 'auto' }}
                icon={<QuestionCircleOutlined />}
                onClick={() => {
                  window.open(
                    helpLink(
                      helpCenterLinks.de.onboarding.stepUploadDLSDocuments[
                        onboarding.software
                      ]
                    ),
                    '_blank'
                  )
                }}
              >
                <span style={{ whiteSpace: 'normal' }}>
                  {t('frontend:onboarding.dlsHelpQuestion', {
                    software: softwareName,
                  })}
                </span>
              </Button>
            </Col>
          )}
          <Col span={24}>
            <Suspense fallback={<LoadingAnimation />}>
              <FileInputFormItem
                required={true}
                buttonText={
                  <Space>
                    <FilePdfOutlined />
                    <span>{t('frontend:onboarding.dlsChooseFile')}</span>
                  </Space>
                }
                name={['fileList']}
                parentPath={`onboarding/${companyUid}/dls/`}
                //accept={['.pdf', '.csv', '.xls', '.xlsx', '.txt']}
                maxCount={20}
                setLoading={uploading}
                sessionToken={sessionToken}
              />
            </Suspense>
          </Col>
        </ConfigProvider>
        <Col span={24} style={{ textAlign: 'right' }}>
          <Space>
            <Button type="text" onClick={() => goToPrevious()}>
              {t('frontend:common.back')}
            </Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              {goToNextText}
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  )
}
